import eventBus from './eventBus'

/**
 * Custom UI Service
 * Provides a unified interface for Toast, MessageBox, and Loading
 */

const messageBase = (options) => {
    if (typeof options === 'string') {
        eventBus.emit('notify', { type: 'info', message: options })
    } else {
        eventBus.emit('notify', {
            type: options.type || 'info',
            title: options.title,
            message: options.message || '',
            duration: options.duration,
            onClose: options.onClose
        })
    }
}

export const message = Object.assign(messageBase, {
    success(options, duration = 3000) {
        const payload = typeof options === 'string' ? { message: options, duration } : options
        eventBus.emit('notify', { type: 'success', title: '成功', ...payload })
    },
    error(options, duration = 4000) {
        const payload = typeof options === 'string' ? { message: options, duration } : options
        eventBus.emit('notify', { type: 'error', title: '错误', ...payload })
    },
    warning(options, duration = 3500) {
        const payload = typeof options === 'string' ? { message: options, duration } : options
        eventBus.emit('notify', { type: 'warning', title: '提醒', ...payload })
    },
    info(options, duration = 3000) {
        const payload = typeof options === 'string' ? { message: options, duration } : options
        eventBus.emit('notify', { type: 'info', title: '提示', ...payload })
    }
})

export const notification = (options) => {
    eventBus.emit('notify', {
        type: options.type || 'info',
        title: options.title || '通知',
        message: options.message || '',
        duration: options.duration || 4500
    })
}

export const messageBox = {
    alert(message, title = '提示', options = {}) {
        return new Promise((resolve) => {
            eventBus.emit('show-message-box', {
                type: 'alert',
                title,
                message,
                confirmButtonText: options.confirmButtonText || '确定',
                callback: resolve
            })
        })
    },
    confirm(message, title = '确认', options = {}) {
        return new Promise((resolve, reject) => {
            eventBus.emit('show-message-box', {
                type: 'confirm',
                title,
                message,
                confirmButtonText: options.confirmButtonText || '确定',
                cancelButtonText: options.cancelButtonText || '取消',
                onConfirm: resolve,
                onCancel: reject
            })
        })
    },
    prompt(message, title = '输入', options = {}) {
        return new Promise((resolve, reject) => {
            eventBus.emit('show-message-box', {
                type: 'prompt',
                title,
                message,
                inputValue: options.inputValue || '',
                inputPlaceholder: options.inputPlaceholder || '请输入...',
                confirmButtonText: options.confirmButtonText || '确定',
                cancelButtonText: options.cancelButtonText || '取消',
                onConfirm: resolve,
                onCancel: reject
            })
        })
    }
}

export const loading = {
    show(text = '加载中...') {
        eventBus.emit('show-loading', { show: true, text })
    },
    hide() {
        eventBus.emit('show-loading', { show: false })
    },
    // Compatibility with ElLoading.service
    service(options = {}) {
        this.show(options.text)
        return {
            close: () => this.hide()
        }
    }
}

export default {
    message,
    messageBox,
    loading
}
